import { useMemo } from 'react';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import type { UseResourceCustomContext } from '@atlassian/jira-resource-with-custom-router-context/src/controllers/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { useIsGettingStartedPageExcludedProject } from '../getting-started-excluded-project/useIsGettingStartedPageExcludedProject.tsx';
import { useGetNpleDisabledProjectPropertyWithFF } from '../get-nple-disabled-project-property/useGetNpleDisabledProjectProperty.tsx';

export const useIsGettingStartedPageEnabled = (customContext?: UseResourceCustomContext) => {
	const { data, loading: projectContextLoading } = useProjectContext(customContext) || {};
	const { simplified: isSimplified = false, isProjectAdmin, projectKey, projectId } = data || {};

	const [isLoading, isExcludedProject] = useIsGettingStartedPageExcludedProject(
		projectId?.toString(),
		customContext,
	);
	const [npleDisabled, isGetNpleDisabledLoading] = useGetNpleDisabledProjectPropertyWithFF(
		projectKey,
		customContext,
	);

	const isDataLoading =
		isLoading ||
		projectContextLoading ||
		(isGetNpleDisabledLoading && fg('gsp_production_rollout'));

	const { appPermissions } = useTenantContext() || {};
	const hasJSMAccess = !!appPermissions?.hasServiceDeskAccess;

	return useMemo(
		() => [
			isDataLoading,
			!isDataLoading
				? hasJSMAccess &&
					isProjectAdmin &&
					!isSimplified &&
					!isExcludedProject &&
					!npleDisabled &&
					fg('gsp_production_rollout')
				: false,
		],
		[isDataLoading, isProjectAdmin, isSimplified, isExcludedProject, npleDisabled, hasJSMAccess],
	);
};
